// extracted by mini-css-extract-plugin
module.exports = {"componentsCopyToClipboard":"styles_componentsCopyToClipboard__ww0rc"};